import { OrderedMap, fromJS, OrderedSet } from 'immutable';
import { AnyAction } from 'redux';

import { TypedMap } from 'utils/typed-map';
import type Organization from 'entities/organization/model';

import { ADD, ADD_MULTIPLE, SET_DISPLAYED_ORGANIZATION_IDS } from './types';

export type OrganizationState = TypedMap<{
  organizations: OrderedMap<string, Organization>;
  displayedOrganizationIds: OrderedSet<string>;
}>;
const initialState: OrganizationState = fromJS({
  organizations: OrderedMap<string, Organization>(),
  displayedOrganizationIds: OrderedSet<string>(),
});

export default (state: OrganizationState = initialState, action: AnyAction): OrganizationState => {
  switch (action.type) {
    case ADD:
      return state.set(
        'organizations',
        state.get('organizations').set(action.organization.id, action.organization)
      );

    case ADD_MULTIPLE:
      return state.set('organizations', state.get('organizations').merge(action.organizations));

    case SET_DISPLAYED_ORGANIZATION_IDS:
      return state.set('displayedOrganizationIds', action.organizationIds);

    default:
      return state;
  }
};
